export const USER_REGISTRATION = '/user_module/user_email_signup';
export const FORGET_PASSWORD = '/user_module/forget_password';
export const RESET_PASSWORD = '/user_module/reset_password';
export const RESET_PASSWORD_ADMIN = '/user_module/reset_password_admin';
export const USER_SIGNUP_PROFILE = (provider) =>
  `/user_module/provider/${encodeURIComponent(provider)}/user_information_signup`;
export const DIRECT_CUSTOMER_SIGNUP = '/user_module/customer_signup';
export const USER_LOGIN = '/user_module/user_login';
export const UNIFIED_LOGIN = '/login/';
export const TENANT_ADMIN_SET_PASSWORD = '/admin/invitations/set-password/';
export const PUBLIC_COMPANIES = '/public/companies/';
export const MAKE_COMPANY_PROFILE = '/booking/create_company';
export const UPDATE_COMPANY_PROFILE = '/booking/update_company';
export const COMPANY_PRIVACY_POLICY = (provider) =>
  `/booking/provider/${encodeURIComponent(provider)}/legal/privacy-policy/`;
export const COMPANY_TERMS_CONDITIONS = (provider) =>
  `/booking/provider/${encodeURIComponent(provider)}/legal/terms-conditions/`;
export const COMPANY_INTEGRATIONS = '/booking/integrations/';
export const GET_COMPANY_TIMEZONES = '/booking/timezones';
export const GET_TAX_LIST = '/booking/get_tax';
export const GET_ZIP_CODES = '/booking/restricted-zip-codes';
export const GET_SERVICE_RESTRICTIONS = '/service_provider/get_service_area_restriction';
export const SERVICE_AREA_RESTRICTION = '/service_provider/service_area_restriction';
export const CREATE_TAX = '/booking/create_tax';
export const UPDATE_TAX = '/booking/update_tax';
export const DELETE_TAX = (taxId) => `/booking/taxes/${encodeURIComponent(taxId)}/`;
export const GET_SERVICE_LIST = '/booking/get_service';
export const DELETE_SERVICE = '/booking/delete_service';
export const CREATE_SERVICE = '/booking/create_service';
export const RETRIEVE_SERVICE = '/booking/retrieve_service';
export const DELETE_PACKAGE = '/booking/delete_package';
export const UPDATE_SERVICE_STATUS = '/booking/update_service_status';
export const UPDATE_SERVICE = '/booking/update_service';
export const DELETE_EXTRAS = '/booking/delete_extras';
export const CREATE_EXTRA = '/booking/create_extras';
export const UPDATE_EXTRA = '/booking/update_extras';
export const CREATE_PACKAGE = '/booking/create_package';
export const CREATE_ITEM = '/booking/create_item';
export const DELETE_ITEM = '/booking/delete_item';
export const UPDATE_ITEM = '/booking/update_item';
export const UPDATE_PACKAGE = '/booking/update_package';
export const GET_BOOKING_DATA = '/booking/service_booking';
export const CREATE_BOOKING = '/booking/create_booking';
export const GET_SERVICE_PROVIDER_LIST = '/service_provider/cleaner_list';
export const UPDATE_CUSTOMER_PREFERRED_CLEANER = '/service_provider/update_customer_preferred_cleaner';
export const GET_SERVICE_PROVIDERS_BY_BOOKING = '/booking/get_cleaner_against_booking';
export const GENERATE_PAYROLL = '/service_provider/generate_payroll';
export const CREATE_SERVICE_PROVIDER = '/service_provider/create_cleaner';
export const CLEANER_SIGNUP = '/service_provider/cleaner_signup';
export const UPDATE_SERVICE_PROVIDER = '/service_provider/update_cleaner';
export const DELETE_SERVICE_PROVIDER = '/service_provider/delete_cleaner/';
export const GET_PROVIDER_WORK_LIST = '/service_provider/list_leaves';
export const GET_UPCOMING_EVENTS_LIST = '/booking/upcoming_events';
export const CREATE_PROVIDER_LEAVE = '/service_provider/create_leave';
export const DELETE_PROVIDER_LEAVE = '/service_provider/delete_leave';
export const LIST_BOOKING = '/booking/booking_list';
export const DELETE_BOOKING = '/booking/bookings';
export const BULK_DELETE_BOOKINGS = '/booking/bookings/bulk-delete/';
export const BOOKING_APPOINTMENT_DETAILS = '/booking/booking_details';
export const UPDATE_BOOKING_APPOINTMENT = '/booking/update_booking';
export const GET_BOOKING_PROBLEMS = '/booking/get_problem';
export const BOOKING_PROBLEMS = '/booking/booking_problems';
export const GET_BOOKING_CUSTOMS = '/booking/booking_customs';
export const CREATE_BOOKING_PROBLEMS = '/booking/update_create_problem';
export const GET_BOOKING_ATTACHMENTS = '/booking/get_attachment';
export const CREATE_BOOKING_ATTACHMENTS = '/booking/create_attachment';
export const DELETE_ATTACHMENT = '/booking/delete_attachment';
export const UPDATE_BOOKING = '/booking/update_booking';
export const BOOKING_DISPATCH = '/booking/booking_dispatch_list';
export const BOOKING_DISPATCH_TWO = '/booking/dispatch_list';
export const CREATE_BOOKING_DISPATCH = '/booking/create_dispatch';
export const DELETE_BOOKING_DISPATCH = '/booking/delete_dispatch';
export const GET_COMPANY_HOURS = '/service_provider/company_hours';
export const GET_PROVIDER_LIST_TASK = '/service_provider/list_tasks';
export const GET_MANAGER_TASK_LIST = '/service_provider/manager_list_tasks';
export const UPDATE_TASKS = '/service_provider/update_task';
export const DELETE_TASK = '/service_provider/delete_task';
export const COMPLETE_TASK = '/service_provider/complete_task';
export const CREATE_PROVIDER_LIST_TASK = '/service_provider/create_task';
export const GET_BOOKING_DASHBOARD = '/booking/booking_dashboard';
export const GET_CARD_DATA = '/booking/dashboard_data';
export const VALIDATE_CODE = '/booking/validate_code';
export const BOOKING_NOTIFICATION = '/booking/notifications';
export const GET_ADMIN_CHAT = '/booking/get_admin_chat';
export const ADMIN_CHAT = '/booking/admin_chat';
export const MARK_CHAT_READ = '/booking/mark_chat_read';
export const CUSTOMER_BOOKING_USER_SALES = '/booking/user-sales';
export const CUSTOMER_ALL_BOOKINGS = '/booking/user_booking_listing';
export const CUSTOMER_CURRENT_BOOKING = '/booking/user_current_booking';
export const BOOKING_REPORTS = '/booking/booking_reports';
export const GET_ADMIN_CHAT_LIST = '/booking/admin_chat_detail';
export const POST_ADMIN_CUSTOMER_CHAT = '/booking/admin_chat';
export const GET_USER_CHAT_LIST = '/booking/get_user_chat';
export const GET_BOOKING_INVOICES = '/booking/invoices';
export const GET_BOOKING_PAYROLL = '/booking/payroll';
export const GET_PAYROLL_LIST = '/service_provider/cleaner_payroll';
export const GET_PAYROLL_DETAIL = '/service_provider/get_payroll';
export const CHARGE_CUSTOMER = '/booking/charge_booking';
export const ADMIN_SIDE_CUSTOMER_LIST = '/service_provider/customer_list';
export const SUBSCRIBE_CUSTOMER = '/user_module/subscribe/';
export const GET_CLEANER_DETAILS = '/service_provider/cleaner_details';
export const MANAGER_LIST = '/booking/get_managers';
export const BOOKING_SALES_CHART = '/booking/sales_stat/';
export const CUSTOMERS_CHART = '/booking/user_stats/';
export const ADMIN_SIDE_ADD_CUSTOMER = '/service_provider/create_customer';
export const ADMIN_SIDE_ADD_MANAGER = '/service_provider/create_manager';
export const DELETE_MANAGER = '/service_provider/delete_manager/';
export const UPDATE_MANAGER = (managerId) => `/service_provider/managers/${encodeURIComponent(managerId)}/`;
export const ADMIN_SIDE_Update_CUSTOMER = '/service_provider/update_customer';
export const DELETE_CUSTOMER = '/service_provider/delete_customer/';
export const MASK_CUSTOMER = '/service_provider/mask_customer/';
export const CLEANER_LOCATION = '/service_provider/cleaner_location';
export const ADMIN_SIDE_CUSTOMER_BOOKINGS = '/booking/admin_user_booking';
export const CUSTOMER_UPCOMING_BOOKINGS = '/booking/customer_bookings';
export const INBOX_SOCKET = (provider) => `/ws/provider/${encodeURIComponent(provider)}/admin_chat`;
export const CHAT_COLLECTION_ATTACHMENTS = '/booking/chat/collections';
export const CHAT_ATTACHMENT_FILE = '/booking/chat/attachments';
export const CANCEL_BOOKING = '/booking/cancel_booking';
export const COMPLETE_BOOKING = '/booking/mark_complete';
export const LIST_COMMUNICATION_LOGS = '/booking/list_email_logs';
export const ADMIN_CARD_LIST_BOOKING_DETAILS = '/user_module/admin_card_list';
export const FIND_US_LIST = '/user_module/find_us';
export const ADMIN_CARD_LIST_BOOKING_ACH_DETAILS = '/user_module/admin_ach_list';
export const GET_CUSTOMER_WITH_ID = '/booking/get_customer';
export const SERVICE_PROVIDER_PAYMENT_TRANSACTIONS = '/service_provider/payment_transactions';
export const SERVICE_PROVIDER_MARK_PAYMENT_PAID = (transactionId) =>
  `${SERVICE_PROVIDER_PAYMENT_TRANSACTIONS}/${encodeURIComponent(transactionId)}/mark-paid/`;
export const ADMIN_CREATE_APPOINTMENT_BOOKING = '/booking/admin_create_booking';
export const BOOKING_BY_CREATION_DATE = '/booking/booking_by_created';
export const GET_STRIPE_PAYMENTS = '/booking/get_payment';
export const SEARCH_BOOKING_BY_ID = '/booking/get_booking';
export const EXPORT_PDF_PAYROLL = '/booking/payroll_csv';
export const CREATE_PAYROLL_LEDGER = '/booking/create_payroll_ledger';
export const GET_PAYROLL_LEDGER_LIST = '/booking/get_payroll_ledger';

export const FULL_CALENDAR_EVENTS = '/booking/get_events';
export const FULL_CALENDAR_RESOURCES = '/booking/get_resources';
export const DISPATCHER_AVAILABILITY = '/booking/dispatcher_availability';
export const ASSIGN_BOOKING_OLD_DISPATCH = '/booking/new_dispatcher_ajax';
export const ASSIGN_BOOKING_BULK_DISPATCH = '/booking/bulk_dispatcher_ajax';
export const DELETE_BOOKING_BULK_DISPATCH = '/booking/remove_dispatcher_bulk';
export const DELETE_BOOKING_OLD_DISPATCH = '/booking/remove_dispatcher';
export const UPDATE_BOOKING_OLD_DISPATCH = '/booking/update_dispatcher_ajax';
export const UPDATE_BOOKING_BULK_DISPATCH = '/booking/update_dispatcher_bulk';
export const ASSIGN_DISPATCHER = '/booking/assign_dispatcher_ajax';

export const USER_CARD_DETAILS = '/booking/user_card_details';
export const CREATE_CUSTOMER_SIDE_BOOKING = '/booking/user_create_booking';
export const GET_CUSTOMER_PROFILE = '/mobile_side/cleaner/profile';
export const UPDATE_CUSTOMER_PROFILE = '/user_module/update_profile/';
export const CHARGE_TIP_FROM_CUSTOMER = '/booking/charge_tip';
export const USER_SIDE_GET_CARDS = '/user_module/user_card_list';
export const USER_SIDE_GET_ACH_CARDS = '/user_module/user_ach_list';
export const USER_SIDE_DELETE_CARD = '/user_module/delete_user_card';
export const USER_SIDE_ADD_CARDS = '/user_module/add_user_card';
export const ADMIN_ADD_USER_CARDS = '/user_module/admin_add_user_card';
export const USER_SIDE_CREATE_ACH_SETUP = '/user_module/create_ach_setup';
export const EMAIL_TEMPLATE = '/booking/create_email_type';
export const UPDATE_EMAIL_TEMPLATE = '/booking/update_email_type';
export const GET_EMAIL_TEMPLATES = '/booking/get_email_types';
export const GET_EMAIL_TEMPLATES_LIST = '/email_marketing/get-all-template/';
export const POST_EMAIL_TEMPLATES_LIST = '/email_marketing/create-template/';
export const PUT_EMAIL_TEMPLATES_LIST = '/email_marketing/update-template/';
export const DELETE_EMAIL_TEMPLATES_LIST = '/email_marketing/delete-template/';
export const GET_TEMPLATE_VARIABLES = '/email_marketing/template-variables/';
export const GET_TEMPLATE_DETAIL = '/email_marketing/templates/';
export const SEND_EMAIL_TO_CUSTOMERS = '/email_marketing/send-email-with-template/';

export const IMPORT_CUSTOMERS = '/user_module/import_customers';
export const EXPORT_CUSTOMERS = '/booking/customer_csv';
export const GET_CLEARNER_POINTS_MAP_URL = '/booking/get_cleaner_points';
export const GET_CLEANER_LOCATIONS_DASHBOARD = '/booking/cleaner_locations_dashboard/';

export const GET_WORK_CALENDAR = '/service_provider/work_calendar';
export const REORDER_PACKAGES = '/booking/reorder-packages';
export const REORDER_ITEMS = '/booking/reorder-items';
export const REORDER_EXTRAS = '/booking/reorder-extras';
export const REORDER_SERVICES = '/booking/reorder-service/';
export const REORDER_SERVICE_PROVIDERS = '/service_provider/reorder_service_provider/';

export const GET_FREQUENCY_LIST = '/booking/frequency_listing';
export const GET_ELIGIBLE_OFFERS = '/booking/eligible_offers';
export const POST_FREQUENCY = '/booking/create_frequency';
export const UPDATE_FREQUENCY = '/booking/update_frequency';
export const DELETE_FREQUENCY = '/booking/delete_frequency';

export const GET_DEALS_LIST = '/booking/deals_listing';
export const CREATE_DEALS = '/booking/create_deals';
export const CREATE_OFFERS = '/booking/create_deal_offer';
export const DELETE_DEALS = '/booking/delete_deals';
export const DELETE_OFFERS = '/booking/delete_offer';
export const EDIT_OFFERS = '/booking/update_offer';

export const CREATE_PROMO_CARDS = '/booking/promo_gift_card';
export const GET_PROMO_CARDS = '/booking/promo_gift_card_listing';
export const DELETE_PROMO_CARDS = '/booking/delete_promo_gift';

export const USER_CREATE_REVIEW = '/user_module/create_review';
export const PIN_UNPIN_CHAT_API = '/booking/pin-unpin-chat/';
export const CHARGE_TIP = '/booking/charge_tip_open';

export const LINK_EMAIL_RESET = '/user_module/link_email_reset';
export const SEND_LINK_EMAIL_RESET = '/user_module/forget_password_admin';
export const LOGIN_CUSTOMER_ACCOUNT = '/user_module/admin_customer_login';
export const USER_EXPORT = '/user_module/user_export';
export const USER_HIDE_PHONE = '/user_module/hide_phone/';
export const USER_GET_HIDE_PHONE = '/user_module/get_hide_phone/';

export const EVENT_DETAILS = '/booking/event_details/';

export const REVIEW_REQUEST = '/user_module/customer_services';
export const SEND_INVOICE_EMAIL = '/booking/send-invoice-email/';
export const CHECK_USER_CARDS = '/booking/check_user_card';
export const GET_CLEANER_DOCUMENTS = '/service_provider/documents/cleaner/';
export const PUT_CLEANER_DOCUMENTS = '/service_provider/documents/';
export const POST_CLEANER_DOCUMENTS = '/service_provider/documents/';
export const GET_BOOKING_NOTES = '/service_provider/notes/booking/';
export const POST_BOOKING_NOTES = '/service_provider/notes/';
export const PUT_BOOKING_NOTES = '/service_provider/notes/';
export const GET_CLEANER_ASSIGNMENTS = '/booking/cleaner_booking/';

export const SEARCH_USER = '/user_module/search-users/';
export const SERVICE_LISTING_API = '/booking/service_listing';

export const WEATHER_API = '/user_module/weather/';

export const SEND_WORK_SCHEDULE = '/service_provider/send_work_flow/';

export const INBOX_CAPABILITIES = '/booking/inbox/capabilities/';
export const INBOX_CONVERSATIONS = '/booking/inbox/conversations/';
export const INBOX_CONVERSATION = (id) => `${INBOX_CONVERSATIONS}${encodeURIComponent(id)}/`;
export const INBOX_MESSAGES = (id) => `${INBOX_CONVERSATION(id)}messages/`;
export const INBOX_ATTACHMENTS = (id) => `${INBOX_CONVERSATION(id)}attachments/`;
export const INBOX_ATTACHMENT_STATUS = (conversationId, attachmentId) => `${INBOX_ATTACHMENTS(conversationId)}${encodeURIComponent(attachmentId)}/`;
export const INBOX_READ = (id) => `${INBOX_CONVERSATION(id)}read/`;
export const CHAT_ATTACHMENT_DOWNLOAD = (id) => `${CHAT_ATTACHMENT_FILE}/${encodeURIComponent(id)}/file`;

export const LIST_CLEANER_TIPS = '/booking/list-charge-tips/';
